import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faArrowRight, faHandshake } from '@fortawesome/free-solid-svg-icons';
import './ContactBanner.css';

function ContactBanner() {
  return (
    <div className="contact-banner">
      <div className="contact-banner-content">
        <div className="contact-banner-icon">
          <FontAwesomeIcon icon={faHandshake} />
        </div>
        <div className="contact-banner-text">
          <h3>Need professional help?</h3>
          <p>Get in touch with our Magento experts who'll be happy to assist you.</p>
        </div>
        <a href="/contact" className="contact-banner-btn">
          <FontAwesomeIcon icon={faEnvelope} />
          <span>Contact Us</span>
          <FontAwesomeIcon icon={faArrowRight} className="contact-banner-arrow" />
        </a>
      </div>
    </div>
  );
}

export default ContactBanner;
